<template>
  <div class="home">
    <Cabecera />
    <Hero />
    <galeria />
  </div>
</template>

<script>
import Presentacion from "@/components/Presentacion.vue";
import Cabecera from "@/components/Cabecera.vue";
import Hero from "@/components/hero.vue";
import galeria from "@/components/galeria.vue";

export default {
  name: "HomeView",
  components: {
    Presentacion,
    Cabecera,
    Hero,
    galeria,
  },
};
</script>

<style scoped>
.logo {
  height: 20vmin;
  pointer-events: none;
}
</style>
